import script from "./breadcrumbtree.vue?vue&type=script&setup=true&lang=js"
export * from "./breadcrumbtree.vue?vue&type=script&setup=true&lang=js"

import "./breadcrumbtree.vue?vue&type=style&index=0&id=026be675&lang=scss&scoped=true"

import exportComponent from "/root/buildarea/v8-development-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-026be675"]])

export default __exports__